export default "__VITE_ASSET__Cl36LDrC__"